 // import { useState, useEffect } from "react";
// import dynamic from "next/dynamic";

// const getIsMobile = () => global?.window && window.innerWidth <= 768;

// export default function useIsMobile() {
//   const [isMobile, setIsMobile] = useState(getIsMobile());

//   useEffect(() => {
//     const onResize = () => {
//       setIsMobile(getIsMobile());
//     };

//     window.addEventListener("resize", onResize);

//     return () => {
//       window.removeEventListener("resize", onResize);
//     };
//   }, []);

//   return isMobile;
// }


import { useState, useEffect } from "react";

// // Checks the user-agent string for common mobile device patterns
// function isMobileUserAgent(userAgent) {
//   return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
// }

// export default function useIsMobile() {
//   const [isMobile, setIsMobile] = useState(() => {
//     if (typeof navigator !== 'undefined') {
//       return isMobileUserAgent(navigator.userAgent);
//     }
//     return false;
//   });

//   useEffect(() => {
//     if (typeof navigator !== 'undefined') {
//       setIsMobile(isMobileUserAgent(navigator.userAgent));
//     }
//   }, []);

//   console.log("isMobile test", isMobile);
//   return isMobile;
// }

export default function useIsMobile() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const mediaQuery = window.matchMedia('(max-width: 768px)');

    const handleChange = () => {
      setIsMobile(mediaQuery.matches);
    };

    // Initial check
    handleChange();

    // Listen for changes in viewport size
    mediaQuery.addEventListener('change', handleChange);

    // Clean up listener on unmount
    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, []);
  
  return isMobile;
}